module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_android_04-450-1de185a442dc75efd0c6f876b39e1fdf.png";